import type {
  PropsWithChildren,
  ReactElement,
  ReactNode,
} from 'react';

import {
  Button,
  ButtonIcon,
} from '../Button';
import type {
  ButtonProps,
} from '../Button';
import { Dropdown } from '../Dropdown';
import type {
  DropdownBase,
} from '../Dropdown';

export type ButtonDropdownProps = Omit<ButtonProps<'button'>, 'pressed' | 'onClick'> & PropsWithChildren<{
  /**
   * props компонента Dropdown
   */
  dropdown: DropdownBase;

  /**
   * Показывать ли стрелку справа от текста
   */
  hasArrow?: boolean;
}>;

export function ButtonDropdown({
  hasArrow = false,
  children = undefined,
  dropdown,
  ...rest
}: ButtonDropdownProps): ReactElement {
  return (
    <Dropdown
      {...dropdown}
    >
      {({
        isDropdownOpen,
        onClick,
        ref,
      }): ReactNode => (
        <Button
          {...rest}
          pressed={isDropdownOpen}
          onClick={onClick}
          ref={ref}
        >
          {children}

          {
            hasArrow && (
              <ButtonIcon
                isRight
              >
                {
                  isDropdownOpen ? (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 6.9126L5 11.9126L6.175 13.0876L10 9.27093L13.825 13.0876L15 11.9126L10 6.9126Z"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.825 6.9126L10 10.7293L6.175 6.9126L5 8.0876L10 13.0876L15 8.0876L13.825 6.9126Z"
                      />
                    </svg>
                  )
                }
              </ButtonIcon>
            )
          }
        </Button>
      )}
    </Dropdown>
  );
}
